import { Title, Box, Stack, Text } from "@skailer-com/uikit";
import useDataProtectionHook from "@/hooks/use-data-protection.hook.ts";
import { DataProtectionResponseForm } from "@/pages/security/components/DataProtectionResponseForm.tsx";
import { DataProtectionResponseLetter } from "@/pages/security/components/DataProtectionResponseLetter.tsx";
import { FullScreenCard } from "@/pages/security/components/FullScreenCard.tsx";
import analyticsService, {
  analyticEvents,
  analyticProperties,
} from "@/services/analytics-service.ts";
import { DataProtectionResponsePage } from "@/types/data-protection.types.ts";
import { useState } from "react";
import { useEffectOnce } from "react-use";

export interface DataProtectionResponseProps {
  page: DataProtectionResponsePage;
}

export function DataProtectionResponse({ page }: DataProtectionResponseProps) {
  const [responseSent, setResponseSent] = useState<boolean>();
  const [responseSentType, setResponseSentType] = useState<DataProtectionResponsePage>(page);
  const { getDataForResponsePage } = useDataProtectionHook();
  const pageData = getDataForResponsePage(page);
  const responseData = getDataForResponsePage(responseSentType);

  useEffectOnce(() => {
    analyticsService.trackEvent(analyticEvents.dataProtection.responsePageViewed, {
      [analyticProperties.actionType]: pageData.analyticsPage,
    });
  });

  return (
    <FullScreenCard>
      <Stack gap={"sm"} className={"w-full sm:max-w-2xl"}>
        <Box className="w-full p-6 lg:p-8 bg-light rounded-xs shadow-md">
          <Stack gap={"2xl"}>
            {responseSent && (
              <Stack gap={"md"}>
                <Title header={responseData.finalTitle} />
                <Text>{responseData.finalText}</Text>
              </Stack>
            )}
            {!responseSent &&
              (~[DataProtectionResponsePage.accept, DataProtectionResponsePage.decline].indexOf(
                page
              ) ? (
                <DataProtectionResponseLetter
                  page={page}
                  onSent={(responseType) => {
                    setResponseSent(true);
                    setResponseSentType(responseType ?? page);
                  }}
                />
              ) : (
                <DataProtectionResponseForm
                  page={page}
                  onSent={() => {
                    setResponseSent(true);
                  }}
                />
              ))}
          </Stack>
        </Box>
      </Stack>
    </FullScreenCard>
  );
}
